module.exports = {
  endpointUrl: "/auth-back/",
  successUrl: "/",
    ldapOptions: {
      enableStrategy: false
    }
};
